export const ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE = 'adminApplicationNavigator';
export const PATH_NAME = '/admin/application-navigator';
